import { Routes } from '@angular/router';

export const full: Routes = [
  {
    path: 'connect-shop/:token',
    loadChildren: () =>
      import('../../features/connect-shop/connect-shop.component').then(m => m.CONNECT_SHOP_ROUTES)
  }
];
